var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarConnection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7148 13.0947V16.2376",
    stroke: "#8298ab",
    strokeWidth: 0.785714,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1426 14.666H17.2854",
    stroke: "#8298ab",
    strokeWidth: 0.785714,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85389 4.18983C7.85389 3.90053 7.61937 3.66602 7.33008 3.66602C7.04079 3.66602 6.80627 3.90053 6.80627 4.18983V5.48377H5.23512C4.65654 5.48377 4.1875 5.95281 4.1875 6.53139V16.2393C4.1875 16.8179 4.65653 17.2869 5.23512 17.2869H12.4417C12.1889 16.9719 11.9807 16.6195 11.8267 16.2393L5.23512 16.2393L5.23512 9.63746H16.7589V10.6078C17.1306 10.7034 17.4823 10.8487 17.8065 11.0362V6.53139C17.8065 5.95281 17.3375 5.48377 16.7589 5.48377H15.1879V4.18983C15.1879 3.90053 14.9534 3.66602 14.6641 3.66602C14.3748 3.66602 14.1403 3.90053 14.1403 4.18983V5.48377H7.85389V4.18983ZM14.1403 6.53139H7.85389V7.29776C7.85389 7.58705 7.61937 7.82157 7.33008 7.82157C7.04079 7.82157 6.80627 7.58705 6.80627 7.29776V6.53139H5.23512V8.58984H16.7589V6.53139H15.1879V7.29776C15.1879 7.58705 14.9534 7.82157 14.6641 7.82157C14.3748 7.82157 14.1403 7.58705 14.1403 7.29776V6.53139ZM6.2832 10.9301H7.33082V11.838H6.2832V10.9301ZM11.5203 10.9301H10.4727V11.838H11.5203V10.9301ZM7.33082 12.7474H6.2832V13.6554H7.33082V12.7474ZM10.4727 12.7474H11.5203V13.6554H10.4727V12.7474ZM6.2832 14.5599H7.33082V15.4679H6.2832V14.5599ZM11.5203 14.5599H10.4727V15.4679H11.5203V14.5599Z",
    fill: "#8298ab"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7151,
    cy: 14.6663,
    r: 2.69388,
    stroke: "#8298ab",
    strokeWidth: 0.897959
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarConnection);
export default __webpack_public_path__ + "static/media/calendar-connection.de2924c6.svg";
export { ForwardRef as ReactComponent };